import {useEffect} from 'react'

import {useDispatch} from 'redux-react-hook'
import ApiSdk from 'services/callApi'
import {auth as authAction} from 'actions'

function useAuth () {
  const dispatch = useDispatch()
  useEffect(() => {
    async function fetchData () {
      let auth
      try {
        auth = await ApiSdk.common.getUserCenterAuth()
      } catch {
        auth = false
      }
      dispatch(authAction(auth))
    }
    fetchData()
  }, [dispatch])
}

export default useAuth
